import { z } from 'zod';

import { AMOUNT_REQUEST_MAX_AMOUNT_CENTS } from '@Common/constants';

export const ZodCurrency = z.enum(['GBP', 'USD', 'EUR']);

export type Currency = z.infer<typeof ZodCurrency>;

/**
 * value represents numbers in CENTS.
 * For 10.00 euros, value would be 1000
 *
 * is_precise indicates to frontend that it's
 * a value with high precision and they will show
 * greater number of digits
 */
export const ZodAmount = z.object({
  value: z.number(),
  currency: ZodCurrency,
  is_precise: z.boolean().optional(),
});

export type Amount = z.infer<typeof ZodAmount>;
export const ZodAmountRequest = z.number().min(0).max(AMOUNT_REQUEST_MAX_AMOUNT_CENTS);

export const ZodIntegerAmountValue = z.number().int().min(0).max(AMOUNT_REQUEST_MAX_AMOUNT_CENTS);

export function makeNullableAmount({
  amount,
  currency,
  isPrecise: is_precise,
}: {
  amount: number | null | undefined;
  currency: Currency;
  isPrecise?: boolean;
}): null | Amount {
  return amount === null || amount === undefined
    ? null
    : {
        value: amount,
        currency,
        is_precise,
      };
}
